<template>
  <base-list
    mode="loadMore"
    :show-load-more="true"
    :items="links"
    :count="count"
    :loading="loading"
    :page-size="pageSize"
    @reached-bottom="$emit('bottom-reached')"
  >
    <template #loading>
      <base-skeleton
        v-for="n in 4"
        :key="`outr_activity_skeleton__${n}`"
        :opacity="0 + (1 /n)"
      >
        <div class="d-flex row m-0">
          <div class="w-100 d-flex align-items-end">
            <div
              class="skeleton__item col-11 mr-1"
            />
            <div
              class="skeleton__item col-1"
            />
          </div>
        </div>
      </base-skeleton>
    </template>
    <template v-slot:default="{item}">
      <base-cell
        class="d-flex py-3 my-1"
      >
        <div class="col-11">
          <base-text
            size="md"
            class="cursor-pointer link"
            @click.native="openInNewTab(item.url)"
          >
            {{ item.url }}
          </base-text>
        </div>
        <div
          class="col-1 clickable underline"
          @click="onViewDetail(item)"
        >
          <base-text
            size="md"
            class="count"
          >
            {{ item.count }}
          </base-text>
        </div>
      </base-cell>
    </template>
  </base-list>
</template>
<script>
export default {
  name: 'EventsList',
  props: {
    links: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    pageSize: {
      type: Number,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      modalUrl: '',
      modalCount: 0,
    };
  },
  computed: {
    outreachId() {
      return this.$route.params.id;
    },
  },
  methods: {
    onViewDetail({ url, count }) {
      // Show link clicks detail
      // Retrieve events
      this.modalUrl = url;
      this.modalCount = count;
      this.$emit('view-details', { url, count });
    },
    onModalClosed() {
      this.modalUrl = null;
      this.modalCount = null;
    },
  },
};
</script>
<style lang="scss" scoped>
.link {
  color: $black;
}
.count {
  color: #000;
}
.clickable {
  cursor: pointer;
  &.underline:hover {
    text-decoration: underline;
  }
}
</style>
